import {IconProps} from './types';

const SupportPerson = ({fill = 'currentColor', className, width = 20, height = 20}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 20"
        className={className}
    >
        <g stroke={fill} strokeLinecap="round" strokeLinejoin="round">
            <circle cx="10" cy="5.5" r="3.5" />
            <path d="M3.75 17.5a6.25 6.25 0 0 1 12.5 0" />
            <path d="M10 13.75v2.5M7.5 15l5 2.5M12.5 15l-5 2.5" />
        </g>
    </svg>
);

export default SupportPerson;
